import React, { useMemo } from "react";
import { motion } from "framer-motion";
import { TP_IMG } from "../../data/constants";

// Rising oocyst bubbles + drifting toilet paper for maximum brainrot depth.
export const FloatingParticles = () => {
  const bubbles = useMemo(
    () =>
      Array.from({ length: 22 }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        size: 8 + Math.random() * 46,
        delay: Math.random() * 14,
        duration: 10 + Math.random() * 16,
        hue: Math.random() > 0.5 ? "#b026ff" : "#5b6bff",
        opacity: 0.25 + Math.random() * 0.4,
      })),
    []
  );

  const rolls = useMemo(
    () =>
      Array.from({ length: 4 }).map((_, i) => ({
        id: i,
        left: 8 + Math.random() * 84,
        size: 42 + Math.random() * 46,
        delay: Math.random() * 8,
        duration: 20 + Math.random() * 14,
        rotate: Math.random() * 360,
      })),
    []
  );

  return (
    <div className="pointer-events-none fixed inset-0 z-[-1] overflow-hidden" aria-hidden data-testid="floating-particles">
      {bubbles.map((b) => (
        <span
          key={b.id}
          className="absolute bottom-[-60px] rounded-full"
          style={{
            left: `${b.left}%`,
            width: b.size,
            height: b.size,
            background: `radial-gradient(circle at 35% 30%, #ffffffaa, ${b.hue})`,
            boxShadow: `0 0 ${b.size / 2}px ${b.hue}`,
            opacity: b.opacity,
            animation: `float-up ${b.duration}s linear ${b.delay}s infinite`,
          }}
        />
      ))}
      {rolls.map((r) => (
        <img
          key={`tp-${r.id}`}
          src={TP_IMG}
          alt=""
          className="absolute bottom-[-120px]"
          style={{
            left: `${r.left}%`,
            width: r.size,
            transform: `rotate(${r.rotate}deg)`,
            opacity: 0.5,
            filter: "drop-shadow(0 0 8px rgba(0,0,0,0.5))",
            animation: `float-up ${r.duration}s linear ${r.delay}s infinite`,
          }}
        />
      ))}
    </div>
  );
};

export default FloatingParticles;
